import ExerciserResultsCardHeader from "../../../others/courses/exercisers/ExerciserResultsCardHeader";
import ExerciserResultsCardHeaderDivider from "../../../dividers/courses/exercisers/ExerciserResultsCardHeaderDivider";
import ExerciserResultsScore from "../../../others/courses/exercisers/ExerciserResultsScore";
import SystemResultsSummaryDivider from "../../../dividers/SystemResultsSummaryDivider";
import ExerciserResultsDetailedScores from "../../../others/courses/exercisers/ExerciserResultsDetailedScores";
import {
    ExerciserResultsScoreCardContentLayout
} from "../../../layouts/courses/exercisers/ExerciserResultsScoreCardContentLayout";

export default function ExerciserResultsDesktopScoreCard({scores, total}) {
    // Used in FlashResultsScreen to display flash score summary

    // BUILD
    return (
        <div className={"hidden h-[240px] min-h-[240px] w-[400px] min-w-[400px] sm:flex sm:flex-col bg-backgroundLight5 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px]"}>
            <ExerciserResultsCardHeader headerTitle={"Résultats"} />
            <ExerciserResultsCardHeaderDivider />
            <ExerciserResultsScoreCardContentLayout>
                <ExerciserResultsScore correctAnswers={scores[0]}
                                       total={total}/>
                <SystemResultsSummaryDivider />
                <ExerciserResultsDetailedScores good={scores[0]}
                                                bad={scores[1]} />
            </ExerciserResultsScoreCardContentLayout>
        </div>
    );
}